module.exports = __webpack_public_path__ + "static/media/sub-card-label-3.f9ce20c1.svg";